import { createStore, applyMiddleware, compose } from "redux";
import  { thunk as thunkMiddleware }  from "redux-thunk";
import rootReducer from "./reducers";

// Setup Redux DevTools Extension if available
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Apply middleware
const middleware = [thunkMiddleware];
const enhancer = composeEnhancers(applyMiddleware(...middleware));


const configureStore = (preloadedState) => {
  const store = createStore(rootReducer, preloadedState, enhancer);
  return store;
};

const store = configureStore();
export default store;
